import { render, staticRenderFns } from "./SalesReturns.vue?vue&type=template&id=1842772b&scoped=true&"
import script from "./SalesReturns.vue?vue&type=script&lang=js&"
export * from "./SalesReturns.vue?vue&type=script&lang=js&"
import style0 from "./SalesReturns.vue?vue&type=style&index=0&id=1842772b&prod&lang=scss&"
import style1 from "./SalesReturns.vue?vue&type=style&index=1&id=1842772b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1842772b",
  null
  
)

export default component.exports